export default __webpack_public_path__ + "static/media/midasi_entry_ko_pc@2x.25728187.png";